import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useCallback } from 'react';
import classnames from 'classnames';
import Bundle from "../../Components/Bundle/Bundle";
import Tabs from "../../Components/Tabs/Tabs";
import DependencyManager from "../../DependencyManager";
var css = {
  "bundleTab": "oalp-3crwF",
  "desktop": "oalp-2SHV-",
  "leftAligned": "oalp-cfENS",
  "mobile": "oalp-E5Bzj"
};
import { withComponentDependency } from "./../../ComponentDependency/withComponentDependency";
import { UNKNOWN } from "../../Constants/locations";
import { compose } from 'redux';
import { withRouter } from "../../Helpers/withRouter";
import TrackingInfoManager from "../../Utils/TrackingInfoManager";
var SLIDES_TO_SHOW_DESKTOP = 6;
var SLIDES_TO_SHOW_MOBILE = 2;
export var TabsCarousel = function TabsCarousel(_ref) {
  var data = _ref.data,
    metadata = _ref.metadata,
    VasSheetAsync = _ref.VasSheetAsync,
    track = _ref.track,
    locationId = _ref.locationId,
    browsingMode = _ref.browsingMode,
    name = _ref.name,
    sectionTitlekey = _ref.sectionTitlekey,
    origin = _ref.origin,
    ReactObserver = _ref.ReactObserver,
    onItemView = _ref.onItemView,
    widgetType = _ref.widgetType;
  var _ref2 = metadata || {},
    style = _ref2.style;
  var apiUrl = data.apiUrl,
    tabs = data.tabs,
    bundleType = data.bundleType,
    showEmiPlaceHolder = data.showEmiPlaceHolder,
    _data$showVasStrip = data.showVasStrip,
    showVasStrip = _data$showVasStrip === void 0 ? true : _data$showVasStrip,
    _data$showOlxAutosAdC = data.showOlxAutosAdCardTag,
    showOlxAutosAdCardTag = _data$showOlxAutosAdC === void 0 ? true : _data$showOlxAutosAdC,
    _data$hideShowAllLink = data.hideShowAllLink,
    hideShowAllLink = _data$hideShowAllLink === void 0 ? false : _data$hideShowAllLink,
    emptyCentreImageName = data.emptyCentreImageName,
    count = data.count,
    source = data.source,
    tabLeftAligned = data.tabLeftAligned,
    zrpWidget = data.zrpWidget;
  var tabsData = tabs.map(function (item) {
    var tab = {
      title: item.tabTitle,
      key: item.tabTitle,
      defaultTitleMessage: item.tabTitle
    };
    return tab;
  });
  var PanameraConstants = DependencyManager.getDependency('constants');
  var IS_DEKSTOP = PanameraConstants.platform === 'desktop';
  var _useState = useState(tabs[0]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  var hasMultipleTabs = (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 1;
  var apiParams = hasMultipleTabs ? selectedTab.apiParams : tabs[0].apiParams;
  var showAllUrl = hasMultipleTabs ? selectedTab.showAll : tabs[0].showAll;
  var tabTitle = hasMultipleTabs ? selectedTab.tabTitle : tabs[0].tabTitle;
  function handleTabClick(tab) {
    var _a, _b;
    var newSelectedTab = tabs.find(function (a) {
      return a.tabTitle === tab.key;
    });
    if (newSelectedTab) {
      setSelectedTab(newSelectedTab);
      if ((_b = (_a = metadata === null || metadata === void 0 ? void 0 : metadata.trackingInfo) === null || _a === void 0 ? void 0 : _a.clickEvent) === null || _b === void 0 ? void 0 : _b.name) {
        var trackingInfo = TrackingInfoManager.getTrackingInfo({
          variants_shown: name,
          browsing_location_id: locationId || UNKNOWN,
          browsing_mode: browsingMode,
          origin: origin,
          chosen_option: sectionTitlekey,
          reason: newSelectedTab.tabTitle
        });
        track(metadata.trackingInfo.clickEvent.name, trackingInfo);
      }
    }
  }
  var handleChange = useCallback(function (inView) {
    var _a, _b;
    if (inView && track && ((_b = (_a = metadata === null || metadata === void 0 ? void 0 : metadata.trackingInfo) === null || _a === void 0 ? void 0 : _a.impressionEvent) === null || _b === void 0 ? void 0 : _b.name)) {
      var trackingInfo = TrackingInfoManager.getTrackingInfo({
        variants_shown: name,
        browsing_location_id: locationId || UNKNOWN,
        browsing_mode: browsingMode,
        origin: origin,
        chosen_option: sectionTitlekey
      });
      track(metadata.trackingInfo.impressionEvent.name, trackingInfo);
    }
  }, [browsingMode, locationId, origin, track, name, metadata, sectionTitlekey]);
  if (!VasSheetAsync) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, ReactObserver && /*#__PURE__*/React.createElement(ReactObserver, {
    as: 'div',
    onChange: handleChange
  }), /*#__PURE__*/React.createElement("div", {
    style: style
  }, hasMultipleTabs ? /*#__PURE__*/React.createElement(Tabs, {
    tabsData: tabsData,
    selectedTab: selectedTab.tabTitle,
    onTabClick: handleTabClick,
    tabsClassName: classnames(css.bundleTab, css[PanameraConstants.platform], _defineProperty({}, css.leftAligned, tabLeftAligned))
  }) : null, /*#__PURE__*/React.createElement(Bundle, {
    url: apiUrl,
    apiParams: apiParams,
    bundleType: bundleType,
    showEmiPlaceHolder: showEmiPlaceHolder,
    count: count || (IS_DEKSTOP ? SLIDES_TO_SHOW_DESKTOP : SLIDES_TO_SHOW_MOBILE),
    showAllUrl: showAllUrl,
    selectedTab: tabTitle,
    track: track,
    widgetKey: name,
    metadata: metadata,
    sectionTitlekey: sectionTitlekey,
    onItemView: onItemView,
    source: source || 'bundleCard',
    showVasStrip: showVasStrip,
    showOlxAutosAdCardTag: showOlxAutosAdCardTag,
    emptyCentreImageName: emptyCentreImageName,
    hideShowAllLink: hideShowAllLink,
    zrpWidget: zrpWidget,
    widgetType: widgetType
  })));
};
export default compose(withComponentDependency, withRouter)(TabsCarousel);